
  export default {
	data(){
	  return {
		flexContainer: `d-flex position-absolute top-0 start-0 w-100 h-100 justify-content-center align-items-center`,
		showingMore: false,
		subscribeModal: false
	  }
	},
	created(){
		console.log('hero edu', this.$parent.educator)
	},
	methods: {
		pluralName(input){
			return `${this.$parent.educator.authorfirstname}'s`
		},
		scrollToReviews(){
			// Only run on client side to avoid SSR issues
			if (process.client && typeof document !== 'undefined') {
				var anchor = document.querySelector('#educatorReviews');
				if (anchor) {
					anchor.scrollIntoView();
				}
			}
		}
	  },
	watch: {
		subscribeModal() {
			console.log("modal change", this.subscribeModal);
		}
	}
  }
